import { useNavigate } from "react-router-dom";

const useCustomRouting = () => {
  const navigate = useNavigate();

  const redirectToPath = (path) => {
    if (path.startsWith("/ui")) navigate(path);
    else navigate(`/ui${path}`);
  };

  return { redirectToPath };
};

export default useCustomRouting;
